import { render, staticRenderFns } from "./WechatIcon.vue?vue&type=template&id=291d2581&scoped=true"
import script from "./WechatIcon.vue?vue&type=script&lang=js"
export * from "./WechatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d2581",
  null
  
)

export default component.exports